import Vue from 'vue'
import {getOptions} from './util/applyBase_handleOptions'
import {getStatus} from './util/applyBase_handleStatus'
import {handleFunc} from './util/applyBase_handleFunc'
import {
  canDealWith,
  canExport,
  canApprove,
  canGenerateCard,
  showNextFlowName,
  showExportName,
  showFileHead,
  hasCardNumber
} from './util/applyBase_handleCardTask'
import {handleMonthStatement} from './util/handleReport'
import './util/erp_handle'
import common from '@/pages/ApplyBasic/component'

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
Vue.use(VideoPlayer)

Vue.use(common)
Vue.prototype.ab_getOptions = getOptions
Vue.prototype.ab_getStatus = getStatus
Vue.prototype.ab_handleFunc = handleFunc
Vue.prototype.ab_canDealWith = canDealWith
Vue.prototype.ab_canExport = canExport
Vue.prototype.ab_canApprove = canApprove
Vue.prototype.ab_canGenerateCard = canGenerateCard
Vue.prototype.ab_showNextFlowName = showNextFlowName
Vue.prototype.ab_showExportName = showExportName
Vue.prototype.ab_showFileHead = showFileHead
Vue.prototype.ab_hasCardNumber = hasCardNumber
Vue.prototype.ab_handleReport = handleMonthStatement

Vue.filter('AmountFormat', function (value) {
  let result = ''
  if (!value) {
    result = '0.00'
  } else {
    let initPart = Number(value).toFixed(0) // 获取整数部分
    // let initPartFormat = initPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
    let initPartFormat = initPart
    let floatPart = '.00' // 预定义小数部分
    let value2Array = String(value).split('.')
    if (value2Array.length > 1) {
      // 数据有小数位
      floatPart = value2Array[1].toString()
      result = initPartFormat + '.' + floatPart.substring(0, 2)
    } else {
      result = initPartFormat + floatPart
    }
  }
  return result
})



// WEBPACK FOOTER //
// ./src/custom_conf.js